import ApiService from '@/services/api.service';

const TherapyService = {
    /* getTherapyGroupNotes(param) {        
        var _Url = '/therapies/groupnotes/';        
      const requestData = {
        method: 'get',
        url: _Url,
        params: param
      }
      return ApiService.customRequest(requestData);
    },*/

    // return ApiService.get(`/PatientVitalSigns/${id}`);

    getTherapyGroupNotes(ProgramCodes) {
        return ApiService.get(`/therapies/groupnotes/${ProgramCodes}`);
    },
    getTherapyTreatmentPlan(admid) {
        return ApiService.get(`/therapies/?CanUseInTreatmentPlan=true&AdmissionId=${admid ?? ''}`);
    },
    get(id) {
        return ApiService.get(`/therapies/${id}`);
    },
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: '/therapies/',
            headers: {},
            params: {
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber,
                CategoryCode: parameter.categoryCode
            }
        };
        return ApiService.customRequest(requestData);
    },

    add(data) {
        return ApiService.post(`/therapies`, data);
    },
    delete(Id) {
        return ApiService.delete(`/therapies/${Id}`);
    },
    update(Id, data) {
        return ApiService.put(`/therapies/${Id}`, data);
    }
};

export default TherapyService;
